// extracted by mini-css-extract-plugin
export default {"root":"AccountStatusModal_root__XeRD8","copy":"AccountStatusModal_copy__5mUxH","actions":"AccountStatusModal_actions__PSZDX"};